module.exports = __webpack_public_path__ + "media/images/kds/back-309829d616a2ccd3ab1c848b112993e2.svg";